module.exports = __webpack_public_path__ + "static/media/Lissandra.6419f4dd.png";